import { render, staticRenderFns } from "./OrderWhatsCommentPopup.vue?vue&type=template&id=22fface0&scoped=true"
import script from "./OrderWhatsCommentPopup.vue?vue&type=script&lang=js"
export * from "./OrderWhatsCommentPopup.vue?vue&type=script&lang=js"
import style0 from "./OrderWhatsCommentPopup.vue?vue&type=style&index=0&id=22fface0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fface0",
  null
  
)

export default component.exports